const baseUrl = '/properties';
export const propertiesRoutes = {
  baseUrl: "".concat(baseUrl),
  fee: id => "".concat(baseUrl, "/").concat(id, "/fee"),
  property: id => "".concat(baseUrl, "/").concat(id),
  activate: id => "".concat(baseUrl, "/").concat(id, "/activate"),
  properties: id => "/portfolios/".concat(id, "/properties"),
  propertiesDashboard: id => "/portfolios/".concat(id, "/propertiesdashboard"),
  propertysContacts: id => "".concat(baseUrl, "/").concat(id, "/contacts"),
  propertiesUtilityProvidersV3: id => "".concat(baseUrl, "/").concat(id, "/utilityproviders-v3"),
  propertiesUtilityProvidersLegacy: id => "".concat(baseUrl, "/").concat(id, "/utilityproviders"),
  propertiesAmenities: id => "".concat(baseUrl, "/").concat(id, "/amenities"),
  unitUtilityProviders: (propertyId, unitId) => "".concat(baseUrl, "/").concat(propertyId, "/units/").concat(unitId, "/utilityproviders-v2"),
  unitUtilityProvidersLegacy: (propertyId, unitId) => "".concat(baseUrl, "/").concat(propertyId, "/units/").concat(unitId, "/utilityproviders"),
  progress: propertyId => "".concat(baseUrl, "/").concat(propertyId, "/progress"),
  propertiesList: "".concat(baseUrl, "/list")
};